import { styled } from "styled-components";

const PanelCollapseHeader = styled.div.attrs({
  className: "pb3 pl4 pt3 pr4 items-center tc panel-ch",
})``;

export { PanelCollapseHeader };
